// import PropTypes from 'prop-types'
import React, { useEffect, useRef, useState } from 'react'
import { Button, Tooltip } from '@outbound-ai/ursa'
import styled from 'styled-components'
import { PositionEnum } from 'types/cssTypes'
import { longTextToSmall } from 'utils/helper'

import MenuItems, { IDropdownLabel } from './MenuItems'

// import HamburgerMenu from './hamburgerMenu'
// import './Style.scss'
interface IProps {
  data: IMultiLevelDropdown[]

  onClick?: any
  animation?: any
  icon?: any
  selectedMenu: ISelectedMenu
  changeMenuItem: any
  labelCount: LabelCount
  toolTipMessage?: any
  disabled?: boolean
  dropdownLabel?: IDropdownLabel
}

export interface LabelCount {
  Min: number
  Total: number
}
export interface ISelectedMenu {
  menu: string
  item: string
  activeId: string
}

export interface IMultiLevelDropdown {
  id: string
  value: string
  items: MultiLevelDropdownItem[]
}
export interface MultiLevelDropdownItem {
  id: string
  value: string
  tntId?: number // Optional tntId for tenant items
}

export const MultiLevelDropdown = ({
  data,
  animation = ['slideIn', 'slideOut'],
  onClick,
  icon,
  selectedMenu,
  changeMenuItem,
  labelCount,
  toolTipMessage,
  disabled,
  dropdownLabel,
}: IProps) => {
  const [showMenuItems, changeShowMenuItems] = useState(false)

  function handleClickOutside(event: any, ref: any) {
    if (ref.current && !ref.current.contains(event.target)) {
      changeShowMenuItems(false)
    }
  }
  const menubarRef = useRef(null)

  useEffect(() => {
    document.addEventListener('mousedown', (event) => handleClickOutside(event, menubarRef))
    return () => {
      document.removeEventListener('mousedown', (event) => handleClickOutside(event, menubarRef))
    }
  }, [])

  const showItemsHandler = (event: any) => {
    event.stopPropagation()
    document.getElementById('notificationMenu')?.classList.remove('show')
    document.getElementById('settingsMenu')?.classList.remove('show')
    changeShowMenuItems(!showMenuItems)
  }

  const closeItemsHandler = () => {
    changeShowMenuItems(false)
  }

  return (
    <Div ref={menubarRef} onClick={closeItemsHandler} style={{ display: 'inline-block' }}>
      {showMenuItems ? (
        <Button disabled={disabled} variant="primary" onClick={showItemsHandler} className="custom-multi-level">
          {icon && <div className="icon-container"> {icon}</div>}

          <div className="menu-container">
            {' '}
            <p className="selected-menu">{longTextToSmall(selectedMenu?.menu, labelCount?.Min, labelCount?.Total)}</p>
            <p className="selected-item"> {longTextToSmall(selectedMenu?.item, labelCount?.Min, labelCount?.Total)}</p>
          </div>
        </Button>
      ) : (
        <Tooltip
          tooltipText={toolTipMessage}
          position={PositionEnum.bottom}
          positionTooltipArrow={87}
          tooltipStyles={{
            'min-width': 'auto',
            'max-width': 'fit-content',
            width: 'fit-content',
            transform: `${disabled ? 'translateY(-10%) translateX(-65%)' : 'translateY(20%) translateX(-60%)'}`,
            // fontSize: '12px',
            zIndex: 9999,
            // background: '#FFF',
            // color: '#565B5F',
            hyphens: 'auto',
          }}
        >
          <Button disabled={disabled} variant="primary" onClick={showItemsHandler} className="custom-multi-level">
            {icon && <div className="icon-container"> {icon}</div>}

            <div className="menu-container">
              {' '}
              <p className="selected-menu">{longTextToSmall(selectedMenu?.menu, labelCount?.Min, labelCount?.Total)}</p>
              <p className="selected-item">
                {' '}
                {longTextToSmall(selectedMenu?.item, labelCount?.Min, labelCount?.Total)}
              </p>
            </div>
          </Button>
        </Tooltip>
      )}

      {showMenuItems && (
        <MenuItemsGroup>
          <MenuItems
            showMenuItems={showMenuItems}
            animation={animation}
            data={data}
            onClick={onClick}
            closeMenu={closeItemsHandler}
            selectedMenu={selectedMenu}
            changeMenuItem={changeMenuItem}
            labelCount={labelCount}
            dropdownLabel={dropdownLabel}
          />
        </MenuItemsGroup>
      )}
    </Div>
  )
}

const Div = styled.div`
  .custom-multi-level {
    display: flex;
    align-items: center;
    height: 2.5rem;
    border-radius: 8px;
    padding: 0 1rem;
    text-align: left;
    border: solid 1px ${({ theme }) => theme.colors.primary.neutral};
    background-color: ${({ theme }) => theme.colors.primary.dark};
    .icon-container {
    }
    .menu-container {
      .selected-menu {
        ${({ theme }) => theme.typography.xxs.normal}
        color: ${({ theme }) => theme.colors.primary.light}
      }
      .selected-item {
        ${({ theme }) => theme.typography.s.medium}
        color: ${({ theme }) => theme.colors.neutral.light}
      }
    }
  }
  .custom-multi-level::after {
    display: inline-block;
    margin-left: 0.255em;
    vertical-align: 0.255em;
    content: '';
    border-top: 0.3em solid;
    border-right: 0.3em solid transparent;
    border-bottom: 0;
    border-left: 0.3em solid transparent;
  }
  .custom-multi-level:hover {
    border: solid 1px ${({ theme }) => theme.colors.primary.neutral};
    background-color: ${({ theme }) => theme.colors.primary.neutral} !important;
  }
`

const MenuItemsGroup = styled.div``
